/**
 * Created by Mark on 17/04/2017.
 */

import React from 'react';
import {ListGroupItem , Thumbnail , ListGroup  ,  Button , FormControl , FormGroup ,  Navbar , NavDropdown , MenuItem , Nav , NavItem , Modal , Row , Col} from 'react-bootstrap';
import Card from './card.js';
import CDNImage from '../components/media/image.js';
import CDNAudio from '../classes/audio.js';
import ContentService from '../services/content-service.js';
import ContentStore   from '../store/content-store.js';
import ContentModel   from './content-edit-model.js';

export default  class VocabCreate  extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            vocabObject:this.props.vocab,
        }

        console.log(this.props.vocab)
    }

    playAudio(path){
        (new CDNAudio(path)).play();
    }


    render()
    {


        return <div className=" p-t-20">
            <ListGroup className="b-1 p-20">
                <ListGroupItem>{this.props.vocab.originalVerb}    <span className="pull-right" onClick={this.playAudio.bind(this ,  this.props.vocab.audio)} ><CDNImage size={15} src="img/audioWordPod.png"/></span></ListGroupItem>
              </ListGroup>

        </div>
    }

}


// WEBPACK FOOTER //
// ./src/components/content-target-verb.js